module.exports = __webpack_public_path__ + "static/img/infobg.cdcd314b.jpg";